import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../../environments/environment';

import { DashboardPreference } from '../buyer-api/survey.interface';

@Injectable({
  providedIn: 'root',
})
export class DashboardPreferenceService {
  private readonly _baseUrl = environment.pureSpectrum.url;

  constructor(private _http: HttpClient) {}

  getDashboardPreference(isServiceBuyer: boolean, isMultiBuyer: boolean) {
    const isService = isServiceBuyer || isMultiBuyer;
    return this._http.get<DashboardPreference[]>(
      `${this._baseUrl}/users/dashboard-preference?isServiceBuyer=${isService}`
    );
  }

  saveDashboardPreference(preferences: DashboardPreference[]) {
    return this._http.post<DashboardPreference[]>(
      `${this._baseUrl}/users/dashboard-preference`,
      preferences
    );
  }
}
